import angular from 'angular';
import StoreFeaturesComponent from './store-features.component';

let StoreFeaturesModule = angular.module('home.storeFeatures',[])
    .component('storeFeatures',StoreFeaturesComponent);

export default StoreFeaturesModule;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/store-features/store-features.js
 **/